
import { styled } from '@mui/material/styles';
import MuiTableRow from '@mui/material/TableRow';

export const EDStickyTableRow: React.FC<React.PropsWithChildren> = props => (
  <StyledTableRow>{props.children}</StyledTableRow>
);

const StyledTableRow = styled(MuiTableRow, { name: 'StickyTableRow' })(() => ({
  height: 'var(--row-height)',
  position: 'relative',
}));
